"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _availability2 = require("availability");

var availability = _interopRequireWildcard(_availability2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var self = {};

self.toTimeText = function (params) {
    var milliseconds = params.milliseconds;
    var basetext = params.basetext;
    var i18n = params.i18n;

    if (milliseconds == null) {
        return "";
    }

    var now = moment().valueOf();

    var time = milliseconds - now;
    time = Math.ceil(time / 60 / 1000);

    if (time > 60) return "";

    if (time > 1) return i18n.get(basetext, { params: { 'minutes': time } });

    return i18n.get(basetext + "OneMinute");
};

self.getCombinedStatus = function (_availability, time) {
    var when = time.valueOf() || Number.MAX_VALUE; // Has to be before the iterator since
    // the iterator changes cachedTime.valueOf()

    var _availability = _availability || { weekly: [], exceptions: [] };
    var util = new availability.AvailabilityIterator({
        cal: time.clone(),
        availability: _availability || {}
    });

    if (!util.hasNext()) {
        return { "available": { when: Number.MAX_VALUE }, "unavailable": { when: Number.MAX_VALUE } };
    }

    var ret = { "available": {}, "unavailable": {} };

    var nowStatus = util.next();

    ret[nowStatus.status].when = when;
    ret[nowStatus.status].until = nowStatus.until || Number.MAX_VALUE;
    ret[nowStatus.status].comment = nowStatus.comment;
    ret[nowStatus.status].reason = nowStatus.reason;
    when = nowStatus.until || Number.MAX_VALUE;

    if (!nowStatus.until) {
        return ret;
    }

    var nextStatus = util.next();
    while (nextStatus.status === nowStatus.status) {
        ret[nextStatus.status].until = nextStatus.until || Number.MAX_VALUE;
        when = nextStatus.until || Number.MAX_VALUE;

        if (!nextStatus.until) {
            return ret;
        }

        nextStatus = util.next();
    }

    ret[nextStatus.status].when = when;
    ret[nextStatus.status].until = nextStatus.until || Number.MAX_VALUE;
    ret[nextStatus.status].comment = nextStatus.comment;
    ret[nextStatus.status].reason = nextStatus.reason;

    // TODO, until not completely correct here, should go next until hitting the first...

    return ret;
};

self.getStatus = function (availability, time) {
    var statuses = self.getCombinedStatus(availability, time);
    var nextAvailable = statuses['available'].when || Number.MAX_VALUE;
    var nextUnavailable = statuses['unavailable'].when || Number.MAX_VALUE;

    if (nextAvailable < nextUnavailable) {
        return { status: 'available', until: nextUnavailable, reason: statuses['available'].reason, comment: statuses['available'].comment };
    } else {
        return { status: 'unavailable', until: nextAvailable, reason: statuses['unavailable'].reason, comment: statuses['unavailable'].comment };
    }
};

exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/Status.js
// module id = 180
// module chunks = 0